import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Warehouse } from '../models/warehouse.model';

@Injectable({
  providedIn: 'root'
})
export class WarehouseService {

  /**
  * Endpoint for http calls
  */
  private _endpoint: string = environment.api.endpoint;

  constructor(private httpClient: HttpClient) { }

  /**
   * Get a warehouse from the backend by id
   *
   * @param id number id of warehouse to get
   *
   * @returns Observable<Warehouse>
   */
  getWarehouseById(id: number): Observable<Warehouse> {

    if (id <= 0 || id === null || id === undefined) {
      throw new Error('WarehouseService: Id must be a valid number');
    }

    return this.httpClient.get(this._endpoint + 'warehouse/' + id).pipe(map((value: any) => {
      return <Warehouse>value;
    }));
  }

  getAllWarehouses(): Observable<Warehouse[]> {
    return this.httpClient.get(this._endpoint + 'warehouse?sort=name,ASC').pipe(map((data) => {
      return <Warehouse[]>data;
    }));
  }

  /**
   * creates a warehouse in the backend based on warehouse object.
   *
   * @param warehouse warehouse object.
   *
   * @returns Observable<Warehouse>
   */
  createWarehouse(warehouse: Warehouse): Observable<Warehouse> {

    if (!warehouse) {
      throw new Error('warehouse service: you must supply a warehouse object for saving');
    }

    delete warehouse.createdAt;
    delete warehouse.updatedAt;

    if (warehouse.id > 0) {
      throw new Error('warehouse service: Cannot create a existing object');
    }

    delete warehouse.id;

    return this.httpClient.post(this._endpoint + 'warehouse',
      JSON.stringify(warehouse),
      { headers: { 'Content-Type': 'application/json' } }).pipe(map((data) => {
        return <Warehouse>data;
      }));
  }

  /**
   * updates a warehouse in the backend based on warehouse object.
   *
   * @param warehouse warehouse object.
   *
   * @returns Observable<Warehouse>
   */
  updateWarehouse(warehouse: Warehouse): Observable<Warehouse> {

    if (!warehouse) {
      throw new Error('warehouse service: you must supply a warehouse object for saving');
    }

    delete warehouse.createdAt;
    delete warehouse.updatedAt;

    if (!warehouse.id || warehouse.id === -1) {
      throw new Error('warehouse service: Cannot update an record without id');
    }

    return this.httpClient.put(this._endpoint + 'warehouse/' + warehouse.id,
      JSON.stringify(warehouse),
      { headers: { 'Content-Type': 'application/json' } }).pipe(map((data) => {
        return <Warehouse>data;
      }));
  }
}
